import axios from 'axios'
import moment from 'moment'

export default {
  async find (id) {
    const path = `${process.env.VUE_APP_API_URL}/api/v2/occurrences/${id}`
    const response = await axios.get(path)

    return response && response.status === 200 ? response.data : null
  },

  async list (filter) {
    const path = `${process.env.VUE_APP_API_URL}/api/v2/occurrences`
    const response = await axios.get(path, {
      params: {
        startDate: filter.startDate ? moment(filter.startDate).format() : null,
        endDate: filter.endDate ? moment(filter.endDate).format() : null,
        searchByDateType: filter.searchByDateType,
        completed: filter.completed,
        name: filter.name,
        sellerId: filter.sellerId,
        autoAnticipation: filter.autoAnticipation,
        applicationName: filter.applicationName,
        taxDocument: filter.taxDocument,
        index: filter.index,
        length: filter.length
      }
    })

    return response && response.status === 200 ? response.data : null
  },

  async finalize (occurence, note, isFraud) {
    const path = `${process.env.VUE_APP_API_URL}/api/v2/occurrences/${occurence.id}/finalize`
    let model = { note: note, isFraud: isFraud }
    const response = await axios.post(path, model)
      .then(response => response)
      .catch(error => error.response)

    return response.data
  },

  async ignoreType (occurenceId, occurenceType, sellerId) {
    const path = `${process.env.VUE_APP_API_URL}/api/v2/occurrences/${occurenceId}/ignore-type`
    let model = { occurrenceType: occurenceType, userId: sellerId }
    const response = await axios.post(path, model)
      .then(response => response)
      .catch(error => error.response)

    return response.data
  }
}
